"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToTopLink = void 0;

var react_1 = __importDefault(require("react"));

var react_scroll_1 = require("react-scroll");

var identity_1 = require("../../identity");

var ToTopLink = function ToTopLink(_a) {
  var theme = _a.theme;
  var style = "w-6 h-12 mb-4 " + (theme ? theme.body.textColor : "text-gray-100") + " hover:" + (theme ? theme.link.hoverColor : "text-red-500") + " font-semibold cursor-pointer";
  var wrapper = "flex flex-col items-center w-20 mx-auto bg-transparent text-center";

  var scrollToTop = function scrollToTop() {
    react_scroll_1.animateScroll.scrollToTop();
  };

  return react_1["default"].createElement("div", {
    className: wrapper
  }, react_1["default"].createElement("a", {
    onClick: function onClick() {
      return scrollToTop();
    },
    className: style
  }, react_1["default"].createElement(identity_1.Icon, {
    name: "arrow_up2",
    size: identity_1.IconSize.xs
  })));
};

exports.ToTopLink = ToTopLink;